import { sendFeedback } from './feedbackV1';
import { Feedback } from 'century-core/typings/Feedback';
import { createFetchRequestWithLocalisedError } from '../utils';

export async function submitFeedback(feedback: Feedback, accessToken: string) {
  return createFetchRequestWithLocalisedError(() => sendFeedback(feedback, accessToken), 'localised-errors-feedback-submit-error');
}
